export default function ProductSpecificationsData(maxAge) {
    return {
        video: {
            name: "About Long Term Care",
            link: "https://player.vimeo.com/video/212993330"
        },
        image: "product-landing/long/circle1.png",
        specs: [
            {
                title: "Eligibility",
                text: `Up to ${maxAge} years`,
            },
            {
                title: "Coverage amounts",
                text: "Benefit amounts built around needs.",
            },
            {
                title: "Who can apply?",
                text: `U.S. citizens or permanent residents`
            },
            {
                title: "Extra benefits",
                text: "Protection for individuals with assets greater than $75,000. Covers expenses that are generally not covered by health insurance, Medicare, or Medicaid."
            }
        ],
        hideNeedsAnalysis: true
    }
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/LTC/ProductSpecificationsData.js